import React from 'react';
import { CheckIcon, GlobeIcon, PlusIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { accessIncludes, valueStack } from '../../data/content';
const receiveItems = ['6 Volumes of practical clinical decision tools', '5 Exclusive Bonuses', 'Clinical cases and real-world scenarios', 'Ready-to-use consultation tools', 'Decision algorithms and visual pathways'];
export function Offer() {
  return <section id="offer" className="w-full bg-white py-14 sm:py-20" data-id="element-240" data-mp="3f2yxwa2bv3vi">
      <div className="mx-auto w-full max-w-3xl px-5" data-id="element-241" data-mp="3jv05vjsgq8fq">
        <p className="text-center text-[0.7rem] font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-242" data-mp="3jxcw0k8djp3v">
          Everything you’ll receive
        </p>
        <h2 className="mt-3 text-center font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-4xl" data-id="element-243" data-mp="3swpzmw9thjgo">
          The Complete Clinical Route for Erectile Dysfunction™
        </h2>

        <ul className="mt-8 space-y-2.5" data-id="element-244" data-mp="1km9juxjprvqx">
          {receiveItems.map((item, index) => <li key={item} data-id="element-245" data-mp="1fllv6iiyjqzv" data-mpi={index}>
              <div className="flex items-start gap-3 rounded-2xl bg-slate-50 px-4 py-3.5 text-[0.95rem] font-semibold leading-snug text-navy-800 ring-1 ring-slate-200" data-id="element-246" data-mp="1fohti7ypwhou">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-247" data-mp="16n0g4xcp2u3u" />
                {item}
              </div>
              {index < receiveItems.length - 1 ? <div className="flex items-center justify-center gap-2 py-1.5 text-[0.65rem] font-bold uppercase tracking-[0.2em] text-slate-400" data-id="element-248" data-mp="1ujo0oy9jumjr">
                  <PlusIcon className="h-3 w-3" aria-hidden="true" data-id="element-249" data-mp="1pji1mx0y9xrn" />
                  Plus
                </div> : null}
            </li>)}
        </ul>

        <p className="mt-6 text-center text-[0.9rem] text-slate-600" data-id="element-250" data-mp="2i8p0xy88ardy">
          Everything is delivered digitally so you can access your Clinical
          Route whenever you need it.
        </p>

        <div className="mt-12 rounded-3xl border border-slate-200 bg-slate-50 p-5 sm:p-7" data-id="element-251" data-mp="3653hce1csw2b">
          <h3 className="text-center font-display text-sm font-extrabold uppercase tracking-[0.14em] text-navy-900" data-id="element-252" data-mp="2sdf58ar3u7lc">
            The real value of this system
          </h3>
          <ul className="mt-5 divide-y divide-slate-200" data-id="element-253" data-mp="2wce8lqx6twao">
            {valueStack.map(line => <li key={line.name} className="flex items-start justify-between gap-4 py-3" data-id="element-254" data-mp="2ihc5tcnn0n23">
                <span className="text-[0.9rem] leading-snug text-slate-700" data-id="element-255" data-mp="29f2z6xvhpdtz">
                  {line.name}
                </span>
                <span className="shrink-0 font-display text-sm font-extrabold text-slate-500 line-through" data-id="element-256" data-mp="2dgeot3ed5z26">
                  {line.value}
                </span>
              </li>)}
          </ul>
          <div className="mt-4 flex items-center justify-between rounded-2xl bg-navy-900 px-4 py-4" data-id="element-257" data-mp="bnqigl6favi6">
            <span className="text-[0.7rem] font-bold uppercase tracking-[0.12em] text-slate-300" data-id="element-258" data-mp="1w6u06rgq44qx">
              Total reference value
            </span>
            <span className="font-display text-2xl font-extrabold text-white line-through decoration-alert-500 decoration-2" data-id="element-259" data-mp="25wnc5tks2lvp">
              $344
            </span>
          </div>

          <div className="mt-5 space-y-1 text-center text-[0.95rem] font-semibold text-slate-600" data-id="element-260" data-mp="2fub6iieh1rdc">
            <p data-id="element-261" data-mp="2avqh7e0rcs3o">But you won’t pay $344.</p>
            <p data-id="element-262" data-mp="2auouudeakj6n">You won’t pay $197.</p>
            <p data-id="element-263" data-mp="2axt43p6m6546">You won’t even pay $97.</p>
          </div>

          <div className="mt-6 rounded-3xl bg-navy-950 px-4 py-7 text-center sm:px-6" data-id="element-264" data-mp="2otybtfabnhbo">
            <p className="text-[0.68rem] font-bold uppercase tracking-[0.16em] text-cyan-bright" data-id="element-265" data-mp="2jx7uypqp0hp7">
              Today you get complete access for only
            </p>
            <p className="mt-2 font-display text-[3.4rem] font-extrabold leading-none text-white sm:text-6xl" data-id="element-266" data-mp="pidmmw4sur3a">
              $27
              <span className="ml-2 align-middle font-display text-lg font-bold text-slate-400" data-id="element-267" data-mp="rvqxpqkpjhfq">
                USD
              </span>
            </p>
            <p className="mt-2 text-[0.8rem] font-bold uppercase tracking-[0.14em] text-gold-500" data-id="element-268" data-mp="w08gpnj8tqpg">
              One-time payment
            </p>

            <div className="mt-5 space-y-1 text-[0.88rem] text-slate-300" data-id="element-269" data-mp="15vijweldo44t">
              <p data-id="element-270" data-mp="89bex3l5w9rx">No monthly fees.</p>
              <p data-id="element-271" data-mp="8a4ffmtj231m">No recurring subscriptions.</p>
              <p data-id="element-272" data-mp="d7w6kemcll4r">Lifetime digital access.</p>
            </div>

            <p className="mx-auto mt-5 flex max-w-xs items-start gap-2 rounded-2xl border border-white/10 bg-white/5 px-3 py-2.5 text-left text-[0.8rem] leading-snug text-slate-300" data-id="element-273" data-mp="d85vrzzkjo9e">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-cyan-bright" aria-hidden="true" data-id="element-274" data-mp="myhb0iopdjvl" />
              The currency conversion is automatic, so you can pay in your local
              currency.
            </p>

            <div className="mx-auto mt-6 max-w-sm" data-id="element-275" data-mp="3j3t763tjv38b">
              <CTAButton label="Yes, I want the complete Clinical Route" size="lg" tone="gold" note="Immediate access · One-time payment · 7-day guarantee" data-id="element-276" data-mp="3j2i280odbpfm" />
            </div>

            <div className="mt-6 space-y-4" data-id="element-277" data-mp="346sfg0bcz89u">
              <CountdownTimer data-id="element-278" data-mp="3483ifxwzcbzw" />
              <ScarcityBar data-id="element-279" data-mp="3045jpobkh37d" />
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-3xl border border-slate-200 bg-white p-5 sm:p-7" data-id="element-280" data-mp="306i6qfw6m3ra">
          <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.14em] text-brand-600" data-id="element-281" data-mp="2vcdyltb6jpom">
            Your access includes
          </h3>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-282" data-mp="2lgaqm6tncwtr">
            {accessIncludes.map(item => <li key={item} className="flex items-start gap-2 text-[0.9rem] font-medium text-slate-700" data-id="element-283" data-mp="2gfd8fu8n02s9">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-284" data-mp="2ch76cziqubdo" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-285" data-mp="1stt5go2q6tm9">
          <CTAButton label="Get instant access for $27" note="Secure payment · Digital delivery" data-id="element-286" data-mp="1sv498nw681dd" />
        </div>
      </div>
    </section>;
}